import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { InternalOrganizationType } from '@/bundle/_MasterAdmin/types/types';

export const getInternalOrganizationDetailsApi = async (): Promise<ApiResponseType<InternalOrganizationType>> => {
  const uri = '/organization/internal/';

  return authApiService.GET(uri);
};
